import { getAplayIdRedirectWebURL } from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
const useOnboardMobileDeviceApi = () => {
  const continueOnMobile = async () => {
    const response = await privateAxios.post(getAplayIdRedirectWebURL);
    return response;
  };

  return { continueOnMobile };
};

export default useOnboardMobileDeviceApi;
